module.exports = __webpack_public_path__ + "static/media/binus_tv_logo.c13de8aa.png";